import * as types from '../actions/action-types.js';

const initialState = {
  openPopover: null
};

export const PopoverTypes = {
  Notification: 'NotificationPopover',
  Profile: 'ProfilePopover'
};

export default (state = initialState, action) => {
  switch(action.type) {
    case types.POPOVERS_OPEN_POPOVER:
      /* switch(action.popover) {
        case PopoverTypes.Notification:
          state.notificationPopoverOpen = true;
          break;
        case PopoverTypes.Profile:
          state.profilePopoverOpen = true;
          break;
        default:
          console.warning('Attempted to open popover that doesn\'t exist...', action.popover);
          break;
      }

      return state; */

      return {
        ...state,
        openPopover: action.popover
      };

    case types.POPOVERS_CLOSE_POPOVER:
      return {
        ...state,
        openPopover: null
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/popover-reducer.js